jQuery(document).ready(function () {
    jQuery(".m-members__nav li").on("click", function () {
        jQuery(".m-members__nav li").removeClass('active'); 
        jQuery(this).addClass('active'); 
    });

    jQuery(".m-members__nav .manufacturing").on("click", function() {
        jQuery(".m-members__list").removeClass('active');
        jQuery(".m-members__list.manufacturing").addClass('active');
    });
    jQuery(".m-members__nav .energy").on("click", function() {
        jQuery(".m-members__list").removeClass('active');
        jQuery(".m-members__list.energy").addClass('active');
    });

    jQuery(".m-members__nav .agriculture").on("click", function() {
        jQuery(".m-members__list").removeClass('active');
        jQuery(".m-members__list.agriculture").addClass('active');
    });

});

